import type { AspectRatio, Platform } from './types';
export const DEFAULT_BRAND_GUIDELINES =
  'Use a clear, friendly tone. Keep copy concise and actionable. Include relevant hashtags. Avoid sensitive claims. Align with brand voice and avoid overuse of emojis.';

export const RATIO_OPTIONS_BY_PLATFORM: Record<
  Platform,
  Array<{ key: AspectRatio; label: string }>
> = {
  email: [{ key: '1:1', label: '1:1 (1024x1024 / 2048x2048)' }],
  whatsapp: [
    { key: '1:1', label: '1:1 (1024x1024 / 2048x2048)' },
    { key: '4:3', label: '4:3 (1280x896 / 2560x1792)' },
    { key: '3:4', label: '3:4 (896x1280 / 1792x2560)' },
  ],
  instagram: [
    { key: '1:1', label: '1:1 (1024x1024 / 2048x2048)' },
    { key: '9:16', label: '9:16 (768x1408 / 1536x2816)' },
    { key: '4:3', label: '4:3 (1280x896 / 2560x1792)' },
    { key: '3:4', label: '3:4 (896x1280 / 1792x2560)' },
  ],
  tiktok: [{ key: '9:16', label: '9:16 (768x1408 / 1536x2816)' }],
  x: [
    { key: '16:9', label: '16:9 (1408x768 / 2816x1536)' },
    { key: '1:1', label: '1:1 (1024x1024 / 2048x2048)' },
    { key: '4:3', label: '4:3 (1280x896 / 2560x1792)' },
  ],
  linkedin: [
    { key: '16:9', label: '16:9 (1408x768 / 2816x1536)' },
    { key: '1:1', label: '1:1 (1024x1024 / 2048x2048)' },
    { key: '4:3', label: '4:3 (1280x896 / 2560x1792)' },
  ],
  facebook: [
    { key: '1:1', label: '1:1 (1024x1024 / 2048x2048)' },
    { key: '16:9', label: '16:9 (1408x768 / 2816x1536)' },
    { key: '4:3', label: '4:3 (1280x896 / 2560x1792)' },
    { key: '3:4', label: '3:4 (896x1280 / 1792x2560)' },
  ],
};

export const ALLOWED_RATIOS: Record<Platform, AspectRatio[]> = {
  email: ['1:1'],
  tiktok: ['9:16'],
  x: ['16:9', '1:1', '4:3'],
  linkedin: ['16:9', '1:1', '4:3'],
  whatsapp: ['1:1', '4:3', '3:4'],
  facebook: ['1:1', '16:9', '4:3', '3:4'],
  instagram: ['1:1', '9:16', '4:3', '3:4'],
};

export const HASHTAGS_MIN = 0;
export const HASHTAGS_MAX = 30;
